<template>
  <q-layout-drawer
    :value="showDrawer"
    :width="width"
    :content-class="[
      'a-layout-drawer',
      'bg-white',
      'no-shadow',
      'text-weight-medium',
      'q-pr-sm',
    ]"
    side="left"
  >
    <q-resize-observable @resize="onResize" />
    <drawer-list-items @resize="onResize" />
    <div slot="mini">
      <drawer-list-items @resize="onResize" />
    </div>
  </q-layout-drawer>
</template>

<script>
import DrawerListItems from './DrawerListItems';
import PerfectScrollbar from 'perfect-scrollbar';


export default {
  name: 'DrawerWrapper',
  components: { DrawerListItems },

  data() {
    return {
      width: 240,
      ps: null,
    };
  },
  methods: {
    onResize() {
      this.ps.update();
    },
  },
  computed: {
    showDrawer() {
      return !!this.$store.state.userSetting['layout.showMiniDrawer'];
    },
  },
  mounted() {
    this.ps = new PerfectScrollbar('.q-layout-drawer', { wheelSpeed: 0.5 });
  },
};
</script>
<style src="perfect-scrollbar/css/perfect-scrollbar.css" />
<style scoped lang="stylus">
@import theme


</style>
